import { IColumn } from '../../store/modules/report/i-column';
import createMongoSort from '../create-mongo-sort';

export interface ISortOption {
  value: string;
  label: string;
}

const optionsForColumn = (column: IColumn): ISortOption[] => [
  { value: createMongoSort(column.field, 'ASC'), label: `${column.header}: ASC` },
  { value: createMongoSort(column.field, 'DESC'), label: `${column.header}: DESC` },
];

const createSortSelectData = (
  columns: IColumn[],
  currentValue?: string,
): ISortOption[] => {
  const visible = columns.filter((column) => !column.hidden).map(optionsForColumn).flat();
  if (!currentValue || visible.some((option) => option.value === currentValue)) {
    return visible;
  }
  const savedColumn = columns.find(
    (column) => column.hidden && optionsForColumn(column).some(
      (option) => option.value === currentValue,
    ),
  );
  return savedColumn ? [...visible, ...optionsForColumn(savedColumn)] : visible;
};

export default createSortSelectData;
